export default "__VITE_ASSET__lgTGzMGQ__"